var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('account-form',{staticClass:"max-w-sm mx-auto pb-24",attrs:{"enable-incomplete-registration":true}})}
var staticRenderFns = []

export { render, staticRenderFns }